export default __webpack_public_path__ + "static/viz-1-e50b54f9ade48435e432ad789b21f16a.webp";